import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';

@Injectable()
export class CorsiService {
  private resourceUrl = environment.apiUrl + 'courses';

  constructor(private http: HttpClient) { }

  getAllCourses(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getAllCoursesMock());
    }
    return this.http.get<any[]>(this.resourceUrl);
  }
  getAllCoursesFormative(mock?: boolean): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl+ '/formative');
  }

  save(request: any, id: number): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/detail/' + id, request);
  }

  saveStudents(request: any, id: number): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/students/' + id, request);
  }

  create(request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, request);
  }

  requestApprovation(courseId: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/request/' + courseId);
  }

  sendToConi(courseId: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/coni/' + courseId);
  }
  sendToSS(courseId: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/ss/' + courseId);
  }
  accept(courseId: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/accept/' + courseId);
  }

  reject(courseId: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/reject/' + courseId);
  }

  certificate(courseId: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/certificate/' + courseId);
  }

  certificateStudents(request: any, courseId: number): Observable<any> {
    return this.http.post<any[]>(this.resourceUrl + '/students/' + courseId + '/certificate/', request);
  }

  getCourse(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/header/' + id);
  }

  getCourseDetail(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/detail/' + id);
  }

  getCourseStudents(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/students/' + id);
  }

  getCourseType(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getCourseTypeMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/type');
  }
  getCourseTypeFormativa(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getCourseTypeMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/type/formativa');
  }

  getCourseDetailType(mock?: boolean): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/detail_type');
  }
  getCourseTypeDidattica(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getCourseTypeMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/type/didattica');
  }
  getQualifications(): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/qualifications');
  }

  getTypologicals(): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/typologicals');
  }

  getCommonSubjects(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getSubjectsMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/subject/common');
  }

  getSpecificSubjects(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getSubjectsMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/subject/specific');
  }

  searchTrainers(request: any, courseId: number, mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.searchSubscriberMock());
    }
    return this.http.post<any[]>( this.resourceUrl + '/search/trainers/' + courseId, request);
  }

  searchStudents(request: any, courseId: number, mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.searchSubscriberMock());
    }
    return this.http.post<any[]>( this.resourceUrl + '/search/students/' + courseId, request);
  }

  searchDisciplineSub(request: any, courseId: number, isTeacher: boolean): Observable<any[]> {
    if (isTeacher){
      return this.http.post<any[]>( this.resourceUrl + '/search/with_discipline/' + courseId + '/?teacher=true', request);
    } else {
      return this.http.post<any[]>( this.resourceUrl + '/search/with_discipline/' + courseId + '/?teacher=false', request);
    }

  }

  projectsearchDisciplineSub(request: any, projectId: number): Observable<any[]> {
      return this.http.post<any[]>( environment.apiUrl + 'project' + '/search/with_discipline/' + projectId + '', request);
  }
  projectsearchSubscriberCompetition(idProject): Observable<any[]> {

    return this.http.get<any[]>( environment.apiUrl + 'project/fe'  + '/search/' + idProject);
  }

  searchSubscriber(request: any, mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.searchSubscriberMock());
    }
    return this.http.post<any[]>( this.resourceUrl + '/search/all', request);
  }
  searchSubscriberCompetition(idCompetition): Observable<any[]> {

      return this.http.get<any[]>( this.resourceUrl + '/search/' + idCompetition);
  }
  loadAttachment(file: File, fileType: number, idCourse: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', fileType + '');
    return this.http.post<any[]>(this.resourceUrl + '/attachment/' + idCourse, formData, {observe: 'response'});
  }

  deleteAttachment(id: number, fileType: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/attachment/' + id + '/' + fileType);
  }

  deleteCorso(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/' + id);
  }


  downloadAllPDF(id: number): Observable<Blob>{
    return this.http.get(this.resourceUrl + '/students/pdf/' + id, {responseType: 'blob'});

  }

  deleteCorsoConi(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/coni/' + id);
  }
  deleteCorsoStudentConi(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/coni/partecipants/' + id);
  }

  private searchSubscriberMock() {
    return [
      {
        code: 'fsd7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'fsd3f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fv7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Magadán',
        firstname: 'Gabriel'
      },
      {
        code: 'gohgdh3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Ancora Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'dfb90b8',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Di Nuovo Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'dfgf3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Proprio Lui Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fsd7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'fsd3f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fv7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Magadán',
        firstname: 'Gabriel'
      },
      {
        code: 'gohgdh3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Ancora Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'dfb90b8',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Di Nuovo Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'dfgf3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Proprio Lui Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fsd7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'fsd3f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fv7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Magadán',
        firstname: 'Gabriel'
      },
      {
        code: 'gohgdh3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Ancora Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'dfb90b8',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Di Nuovo Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'dfgf3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Proprio Lui Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fsd7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'fsd3f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fv7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Magadán',
        firstname: 'Gabriel'
      },
      {
        code: 'gohgdh3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Ancora Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'dfb90b8',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Di Nuovo Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'dfgf3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Proprio Lui Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fsd7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'fsd3f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fv7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Magadán',
        firstname: 'Gabriel'
      },
      {
        code: 'gohgdh3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Ancora Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'dfb90b8',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Di Nuovo Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'dfgf3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Proprio Lui Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fsd7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'fsd3f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fv7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Magadán',
        firstname: 'Gabriel'
      },
      {
        code: 'gohgdh3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Ancora Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'dfb90b8',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Di Nuovo Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'dfgf3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Proprio Lui Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fsd7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'fsd3f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'fv7f',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Magadán',
        firstname: 'Gabriel'
      },
      {
        code: 'gohgdh3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Ancora Matrella',
        firstname: 'Giuseppe'
      },
      {
        code: 'dfb90b8',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Di Nuovo Pochiero',
        firstname: 'Alessandro'
      },
      {
        code: 'dfgf3',
        cf: 'PCHLSN90M10H501P',
        lastname: 'Proprio Lui Matrella',
        firstname: 'Giuseppe'
      },
    ]
  }

  private getAllCoursesMock() {
    return [
      {
        id: 1,
        title: 'Corso di panza',
        type: {id: 1, code: 'SNAC', description: 'Corso di formazione SNAC'},
        comitee: {id: 1, code: 'ASC', description: 'ASC'},
        date: '12/12/2012',
        state: 'NEW',
        canAct: true
      },
      {
        id: 2,
        title: 'Workshop di briscola a 5',
        type: {id: 2, code: 'WS', description: 'Workshop'},
        comitee: {id: 1, code: 'ASC', description: 'ASC'},
        date: '12/12/2012',
        state: 'APP',
        canAct: true
      },
      {
        id: 3,
        title: 'Tutti in seminario',
        type: {id: 3, code: 'SM', description: 'Seminario'},
        comitee: {id: 1, code: 'ASC', description: 'ASC'},
        date: '12/12/2012',
        state: 'NEW',
        canAct: false
      },
    ]
  }

  private getCourseTypeMock() {
    return [
      {id: 1, code: 'SNAC', description: 'Corso di formazione SNAC'},
      {id: 2, code: 'WS', description: 'Workshop'},
      {id: 3, code: 'SM', description: 'Seminario'}
    ]
  }

  private getSubjectsMock() {
    return [
      {id: 1, code: 'MAT1', description: 'Materia 1'},
      {id: 2, code: 'MAT2', description: 'Materia 2'},
      {id: 3, code: 'MAT3', description: 'Materia 3'},
      {id: 4, code: 'MAT4', description: 'Materia 4'},
      {id: 5, code: 'MAT5', description: 'Materia 5'},
      {id: 6, code: 'MAT6', description: 'Materia 6'},
      {id: 7, code: 'MAT7', description: 'Materia 7'},
      {id: 8, code: 'MAT8', description: 'Materia 8'},
      {id: 9, code: 'MAT9', description: 'Materia 9'},
      {id: 10, code: 'MAT10', description: 'Materia 10'},
      {id: 11, code: 'MAT11', description: 'Materia 11'},
      {id: 12, code: 'MAT12', description: 'Materia 12'},
      {id: 13, code: 'MAT13', description: 'Materia 13'},
      {id: 14, code: 'MAT14', description: 'Materia 14'},
      {id: 15, code: 'MAT15', description: 'Materia 15'},
      {id: 16, code: 'MAT16', description: 'Materia 16'},
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/servizi/formativa/corsi.service.ts